"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorInfo = void 0;
var cachedGetResult_1 = require("../cachedGetResult");
var website_1 = require("../website");
var cookie_1 = require("../cookie");
exports.errorInfo = "Opps, something is wrong. Please try again later or contact our customer service officer to assist you.";
var meta = {
    country: "",
    lang: "",
    currency: "",
    priceGraph: ""
};
var userInfo = {
    customerId: "0"
};
var Constant = (function () {
    function Constant() {
    }
    Object.defineProperty(Constant, "countryCode", {
        get: function () {
            return "LITBADOR";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "platform", {
        get: function () {
            return website_1.isPC() ? "pc" : "mobile";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "sid", {
        get: function () {
            return cookie_1.getItem("sid") || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "sessionkey", {
        get: function () {
            return cookie_1.getItem("sessionkey") || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "country", {
        get: function () {
            return meta.country;
        },
        set: function (country) {
            try {
                country && (meta.country = country.toUpperCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "language", {
        get: function () {
            return meta.lang;
        },
        set: function (language) {
            try {
                language && (meta.lang = language.toLowerCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "currency", {
        get: function () {
            return meta.currency;
        },
        set: function (currency) {
            try {
                currency && (meta.currency = currency.toUpperCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "priceGraph", {
        get: function () {
            return meta.priceGraph;
        },
        set: function (graph) {
            try {
                meta.priceGraph = graph;
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "userInfo", {
        get: function () {
            return userInfo;
        },
        set: function (user) {
            userInfo = user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "multiLanImgKey", {
        get: function () {
            return this.language.toLowerCase() + "_" + this.currency.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        cachedGetResult_1.default
    ], Constant, "countryCode", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "platform", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "sid", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "sessionkey", null);
    return Constant;
}());
exports.default = Constant;
